import React, { FC } from 'react';
import { IonList } from '@ionic/react';

export interface AllieMenuListProps {
  children: React.ReactNode;
  className?: string;
  mode?: 'ios' | 'md';
  inset?: boolean;
  style?: React.CSSProperties;
}

/**
 * AllieMenuList - Wrapper around IonList for menu items
 * Provides consistent list styling for menu components
 */
export const AllieMenuList: FC<AllieMenuListProps> = ({
  children,
  className,
  mode = 'md',
  inset = false,
  style,
}) => {
  return (
    <IonList className={className} mode={mode} inset={inset} style={style}>
      {children}
    </IonList>
  );
};

AllieMenuList.displayName = 'AllieMenuList';
